import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import CategoryList from "../../components/CategoryList/categoryList";
import Chatbot from "../../components/Chatbot/Chatbot";
import GrievancesCTA from "../../components/GrievancesCTA/GrievancesCTA";
import Header from "../../components/Header/header";
import PageList from "../../components/PageList/pageList";
import {
  CHATBOT_CONTEXT,
  EVENTS,
} from "../../utils/constants";
import { isTokenPresent } from "../../utils/cookieHelper";
import GlobalChatBot from "../../components/Chatbot/GlobalChatBot/globalChatBot";

import {
  isMobile,
  isMobileBridgePresent,
  ingestData,
  hasMakeRequestBridge,
  getUserAuthLevel,
} from "../../bridges/BridgeServices";
import "./home.scss";
import SearchInput from "../../components/SearchInput/searchInput";
import MobileHeader from "../../components/MobileHeader/mobileHeader";
import { isShowWebHeader } from "../../utils/helperFunctions";
import RecentActivity from "../../components/RecentActivity/recentActivity";
import fetchAuthStatus from "../../services/AuthStatus/authStatus.service";

const Home = ({
  data: { wpPage: { uri = "", categoryAndTag = "" } = {} },
  pageContext: {
    allPagesData = {},
    searchDataArrayObject = [],
  },
}) => {
  const {
    "child-pages": childPages = [],
    "faq-pages": faqPages = [],
    isContactSupportVisible = true,
    seoTitle,
    seoMetaDesc,
    title,
  } = allPagesData[uri] || {};

  useEffect(() => {
    ingestData({
      name: EVENTS.HELP_CENTER_LOADED,
      data: {
        faqTitle: title,
      },
    });

    if (Freshbot?.userAuthLevel) {
      getUserAuthLevel();
    } else {
      fetchAuthStatus();
    }
  }, []);

  return (
    <div className="home-page">
      <Header
        title={seoTitle}
        description={seoMetaDesc}
        searchData={searchDataArrayObject}
        pageURI={uri}
        faqTitle={title}
      />
      {/* adding an extra div for server side rendering */}
      <div className="mobile-search-input-wrapper">
        {isMobile() ? (
          isShowWebHeader() ? (
            <>
              <MobileHeader
                faqTitle={title}
                data={searchDataArrayObject}
              />
              {hasMakeRequestBridge() && <RecentActivity />}
            </>
          ) : (
            <SearchInput data={searchDataArrayObject} />
          )
        ) : null}
      </div>

      <div className="content">
        <CategoryList
          pages={childPages}
          allPagesData={allPagesData}
        />
        <PageList
          pages={faqPages}
          allPagesData={allPagesData}
          heading="Frequently Asked Questions"
          showIcon={false}
          categoryAndTag={categoryAndTag?.categoryAndTag}
        />
        <GrievancesCTA />
        <Chatbot chatBotContext={CHATBOT_CONTEXT.GLOBAL} />
        {isContactSupportVisible &&
          isMobile() &&
          isMobileBridgePresent() &&
          isTokenPresent() &&
          !isShowWebHeader() && (
            <GlobalChatBot faqTitle={title} />
          )}
      </div>
    </div>
  );
};

Home.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default Home;

export const query = graphql`
  query HomePageById($id: String!) {
    wpPage(id: { eq: $id }) {
      uri
      categoryAndTag {
        categoryAndTag
      }
    }
  }
`;
